import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../../services';
@Component({
    selector: 'app-forgot-credentials-component',
    templateUrl: './forgot-credentials.component.html',
    styleUrls: ['../login/login.component.scss', '../layout/layout.component.scss']
})
export class ForgotCredentialsComponentComponent implements OnInit {
    public showSpinner: boolean = false;
    public model: any = {};

    constructor(private authService: AuthenticationService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private router: Router,
        private vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef);
    }

    public ngOnInit() {
        this.model = {
            UserName: '',
            EmailAddress: ''
        }
    }
    public onSubmitForgotPassword() {
        this.showSpinner = true
        this.authService.forgotPassword(this.model)
            .catch((err: any) => {
                console.log(err)
                this.toastr.error(err.Message, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                this.toastr.success(response.Message, 'Email Sent');
                setTimeout(() => {
                    this.router.navigate(['login']);
                }, 1000);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forgot-credentials/forgot-credentials.component.ts